export const MAX_VISIBLE_DOTS = 5
export const DOT_CELL_PX = 14
export const DOT_SIZE = 4
export const ACTIVE_DOT_SIZE = 6

export const CAROUSEL_HOVER_MEDIA = '@media (hover: hover) and (pointer: fine)'
